import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ContactUsDetails,
  ContactUsResponse,
} from './store/state/landing-page.state';

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  private baseUrl: string = environment.baseUrl;

  constructor(private httpClient: HttpClient) {}

  submitContactUs(
    contactUsDetails: ContactUsDetails,
  ): Observable<ContactUsResponse> {
    return this.httpClient.post<ContactUsResponse>(
      `${this.baseUrl}/cm-services/api/v1/support-service/support/contact-us/guest`,
      contactUsDetails,
    );
  }
}
